import React from "react"
import TypeformEmbed from "../common/TypeformEmbed"

const PrepaidDiscount = () => {
  return <TypeformEmbed id="sciJOcvo" />
}

export default PrepaidDiscount
